import dayjs from "dayjs";
import { RyeDropDown } from "../rye/RyeDropDown";
import { RyeMonthPicker } from "../rye/RyeMonthPicker";
import { buildClasses } from "../utils/buildClasses";
import {
  DATE_RANGE_PRESET_LABELS,
  DateRangePreset,
  ReportDateRange,
  selectDateRangePreset,
} from "./reportDateRange";

/**
 * A dropdown of rolling date ranges, plus month pickers when "Custom" is
 * chosen. Each view passes the presets that suit it; "Custom" is always last.
 */
export function ReportDateRangeControl({
  presets,
  range,
  onChange,
}: {
  presets: Exclude<DateRangePreset, "custom">[];
  range: ReportDateRange;
  onChange: (update: (prev: ReportDateRange) => ReportDateRange) => void;
}): JSX.Element {
  return (
    <div className={buildClasses("flex", "items-center", "gap-3")}>
      <RyeDropDown<DateRangePreset>
        entries={[...presets, "custom" as const].map((preset) => ({
          id: preset,
          text: DATE_RANGE_PRESET_LABELS[preset],
          icon: null,
        }))}
        initEntryId={range.preset}
        onSelectEntry={(entry) =>
          onChange((prev) => selectDateRangePreset(prev, entry.id, dayjs()))
        }
        size="sm"
        // Wide enough for "Last 12 months", and no wider, so the header has
        // room for each view's own controls.
        width="sm"
      />
      {range.preset === "custom" && (
        <>
          <RyeMonthPicker
            selectedDate={range.startMonth}
            onDateChange={(date) =>
              onChange((prev) => ({ ...prev, startMonth: date }))
            }
            size="sm"
            width="md"
            placeholder="Start month"
          />
          <span className={buildClasses("text-sm", "text-on-surface-600")}>
            through
          </span>
          <RyeMonthPicker
            selectedDate={range.endMonth}
            onDateChange={(date) =>
              onChange((prev) => ({ ...prev, endMonth: date }))
            }
            size="sm"
            width="md"
            placeholder="End month"
          />
        </>
      )}
    </div>
  );
}
